import {IonGrid, IonRow, IonCol, IonModal, IonButtons, IonButton, IonIcon, IonContent, IonHeader, IonToolbar, IonTitle, useIonRouter, IonCardHeader, IonCardTitle, IonCardContent, IonTextarea} from "@ionic/react";
import {checkmarkOutline, chevronBack, scan} from "ionicons/icons";
import {QrReader} from "react-qr-reader";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {OnResultFunction} from "react-qr-reader/src/types";
import CustomField from "../components/CustomField";
import {useFormInput, validateForm} from "../_/useForms";
import React, {useEffect, useState} from "react";
import indexBy from "underscore/modules/indexBy";
import styles_Modal_2_1 from './Modal_2_1.module.scss';
import {push_pg_0_24__VenderRedeem} from "../store/Pg_2_Store";
import {handleCommonFetchErrors} from "./Utils";
import {Pg_8_5_Store, push_pg_8_5__scan} from "../store/Pg_8_Store";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";


export const useLoginFields = () => {
    return [
        {
            id: "create_nickname",
            label: "暱稱",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "暱稱",
                    autocomplete: "false"
                },
                state: useFormInput("")
            }
        },
    ];
}

export const Modal_8_5_Sms = ({ref_selected_Item_委託建立會員, dismiss, onResult}) => {
    const router = useIonRouter();
    let [mode, setMode] = useState(1);
    const pgData = useStoreState(Pg_8_5_Store, getPageData);

    //#region Back button
    useEffect(() => {
        let callback: any = (ev) => {
            // ev.detail.register(10, () => {
            //     console.log('Handler was called!');
            // });

            dismiss();
        };

        document.addEventListener('ionBackButton', callback);
        // Remove listener on unmount
        return () => document.removeEventListener("ionBackButton", callback);
    }, []);
    //#endregion


    const fields = useLoginFields();
    let keyedFields = indexBy(fields, 'id');

    // useEffect(() => {
    //     keyedFields.手機國碼.input.state.setValue(`${keyedFields.手機號碼.input.state.value}${keyedFields.手機國碼.input.state.value}`)
    // }, [keyedFields.手機號碼.input.state.value, keyedFields.手機國碼.input.state.value]);

    const [errors, setErrors] = useState(false);

    const handleScan = result => {
        if (result) {
            //setQRData(result);
            //play();
            //handleSuccess(result);
            alert(`代碼: ${result.text}`);
            keyedFields.code.input.state.reset(result.text);
            //onResult(result);
        }
    }

    const _push_redeem = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            const create_nickname = fields && (keyedFields.create_nickname as any).input.state.value;
            const create_email = fields && (keyedFields.create_email as any).input.state.value;
            const create_phone = fields && (keyedFields.create_phone as any).input.state.value;
            const create_password = fields && (keyedFields.create_password as any).input.state.value;
            let error: any = null;
            if (error = (await push_pg_8_5__scan({
                create_nickname: create_nickname,
                create_email: create_email,
                create_phone: create_phone,
                create_password: create_password,
            }))) {
                if (!handleCommonFetchErrors(router, error)) { //沒有成功被處理
                    dismiss();

                    if (onResult) {
                        onResult(true);
                    }
                }
            }

        } else {
        }
    }


    return <>
        <IonHeader>
            <IonToolbar>
                <IonTitle>分享個人填表給訪客</IonTitle>
                <IonButtons slot="start">
                    <IonButton onClick={dismiss}>
                        <IonIcon size="large" icon={chevronBack} style={{marginLeft: "-0.7rem"}}/>
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
            <IonGrid>
                {/*<IonRow className="ion-justify-content-center ion-text-center">*/}
                {/*    <IonCol>*/}
                {/*        <IonButton fill={"solid"} onClick={(e) => {*/}
                {/*            e.preventDefault();*/}
                {/*            e.stopPropagation();*/}

                {/*            setMode(1);*/}

                {/*            return false;*/}
                {/*        }}>*/}
                {/*            關閉掃描*/}
                {/*        </IonButton>*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}

                {/*<IonRow className="ion-text-center ion-margin-top" >*/}
                {/*    <IonCol size="12">*/}
                {/*        <IonIcon style={{ fontSize: "5rem" }} icon={ props.modalOptions.icon } />*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}

                {mode === 2 &&
                    <div className={styles_Modal_2_1.readerContainer}>
                        <div className={styles_Modal_2_1.reader}>
                            <QrReader
                                containerStyle={{maxHeight: '350px'}}
                                constraints={{facingMode: 'environment'}}
                                scanDelay={500}
                                videoId={'video'}
                                onResult={handleScan}
                                videoStyle={{height: "350px"}}
                            />
                        </div>
                        <div className={styles_Modal_2_1.readerBg}>
                            <div className={styles_Modal_2_1.readerBgText}>若方框內為空白畫面，表示沒有權限操作相機，請手動輸入兌換碼</div>
                        </div>
                    </div>
                }

                <div>
                    {ref_selected_Item_委託建立會員.current.手機}
                </div>
                <IonRow className="ion-justify-content-center">
                    <IonCol>
                        <a href="sms:+15551234567?body=Support%20Request">Text Us</a>
                    </IonCol>
                </IonRow>

                <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                    <IonCol>
                        <IonButton fill={"solid"} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            _push_redeem();

                            return false;
                        }}>
                            設定生成內容
                        </IonButton>
                    </IonCol>
                </IonRow>

                <IonCardHeader>
                    <IonCardTitle>設定生成內容</IonCardTitle>
                    {/*<IonCardSubtitle>請提供必要資訊</IonCardSubtitle>*/}
                </IonCardHeader>
                <IonCardContent>
                    <IonTextarea class={styles_Modal_2_1.textarea}>
                    </IonTextarea>
                    <IonRow className="ion-margin-top ion-justify-content-end">
                        <IonButton color={'medium'} fill={"solid"} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            _push_redeem();

                            return false;
                        }}>
                            存檔
                        </IonButton>
                        <IonButton color={'medium'} fill={"solid"} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            _push_redeem();

                            return false;
                        }}>
                            取消
                        </IonButton>
                    </IonRow>
                </IonCardContent>

                <IonCardHeader>
                    <IonCardTitle>預覽生成內容</IonCardTitle>
                    {/*<IonCardSubtitle>請提供必要資訊</IonCardSubtitle>*/}
                </IonCardHeader>
                <IonCardContent>
                    <IonTextarea class={styles_Modal_2_1.textarea}>

                    </IonTextarea>
                </IonCardContent>

                {/*<IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">*/}
                {/*    <IonCol>*/}
                {/*        <IonButton fill={"solid"}>*/}
                {/*            兌換*/}
                {/*        </IonButton>*/}
                {/*    </IonCol>*/}
                {/*</IonRow>*/}

                <IonRow>
                    <IonCol>
                        {fields.map((f: any) => {
                            return <CustomField key={f.id} field={f} errors={errors} noLabel={false}/>
                        })}
                    </IonCol>
                </IonRow>

                <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
                    <IonCol>
                        <IonButton fill={"solid"} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            _push_redeem();

                            return false;
                        }}>
                            產生
                        </IonButton>
                    </IonCol>
                </IonRow>

            </IonGrid>
        </IonContent>
    </>;
};
